export default {
  COMMON__MINUTES: '分',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: '修改',
    BUTTON__DELETE: '刪除',
    MESSAGE_STATUS__DELETE: '刪除',
    MESSAGE_MENU__DELETE: '刪除',
    BUTTON__SAVE: '保存',
    BUTTON__CANCEL: '取消',
    BUTTON__CLOSE: '關閉',
    MODAL__CHANNEL_INFORMATION__UPLOAD: '上傳',
    EDIT_PROFILE__IMAGE_UPLOAD: '上傳',
    CHANNEL_LIST__TITLE: '通路',
    CHANNEL_SETTING__HEADER__TITLE: '平臺信息',
    MODAL__USER_LIST__TITLE: '成員',
    CHANNEL_SETTING__MEMBERS__TITLE: '成員',
    NO_MEMBERS: '(空平臺)',
    NO_NAME: '(未知用戶)',
    TOOLTIP__UNKOWN_USER: '(未知用戶)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: '退出平臺',
    BUTTON__INVITE: '邀請',
    MODAL__INVITE_MEMBER__SELECTED: '已選擇',
    MODAL__CREATE_CHANNEL__SELECTED: '已選擇',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: '平臺名稱',
    MODAL__INVITE_MEMBER__TITLE: '添加成員',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: '輸入',
    MESSAGE_INPUT__PLACE_HOLDER: '輸入',
    BUTTON__CREATE: '建立',
    MODAL__CREATE_CHANNEL__TITLE: '新房間',
    TRYING_TO_CONNECT: '正在連接...',
    USER_PROFILE__MESSAGE: '消息',
    USER_PROFILE__USER_ID: '使用者ID',
    EDIT_PROFILE__USERID_LABEL: '使用者ID',
    EDIT_PROFILE__TITLE: '我的個人資料',
    EDIT_PROFILE__IMAGE_LABEL: '頭像',
    EDIT_PROFILE__NICKNAME_LABEL: '昵稱',
    EDIT_PROFILE__THEME_LABEL: '暗色主題',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: '在該房間上無法聊天',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: '讀到此處',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: '激活',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: '全部成員',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: '邀請使用者',
    MODAL__DELETE_MESSAGE__TITLE: '確定要刪除這條消息嗎？',
    MODAL__CHANNEL_INFORMATION__TITLE: '編輯房間信息',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: '房間圖片',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: '輸入姓名',
    TYPING_INDICATOR__IS_TYPING: '輸入中...',
    TYPING_INDICATOR__ARE_TYPING: '輸入中...',
    TYPING_INDICATOR__MULTIPLE_TYPING: '輸入中...',
    TYPING_INDICATOR__AND: '還有',
    MESSAGE_STATUS__SENDING_FAILED: '無法發送消息',
    MESSAGE_STATUS__TRY_AGAIN: '請重試',
    MESSAGE_STATUS__OR: '或',
    PLACE_HOLDER__WRONG: '發生錯誤',
    PLACE_HOLDER__RETRY_TO_CONNECT: '重試',
    NO_TITLE: '無標題',
    TOOLTIP__AND_YOU: ', 還有我',
    TOOLTIP__YOU: '我',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(未知消息)',
    UNKNOWN__CANNOT_READ_MESSAGE: '無法讀取該消息',
    MESSAGE_EDITED: '(已編輯)',
    PLACE_HOLDER__NO_CHANNEL: '開始新對話',
    MESSAGE_MENU__REPLY: '回復',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: '我',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: '回復',
    CHANNEL_SETTING__PROFILE__EDIT: '編輯',
    MESSAGE_MENU__COPY: '復制',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: '確認',
  SETTINGS__NONE: '無',
  SEARCH__USER_PLACEHOLDER: '用姓名/員工號/手機號碼搜索',
  SEARCH__NO_USER_INFO: '無用戶信息.',
  LOGIN__EMAIL_OR_HP: '請輸入Email或手機號碼',
  ELECTRON: {
    MENU_DELETE: '刪除',
    MENU_VIEW: '查看',
    MENU_SIGN_OUT: '登出',
    MENU_SETTINGS: '設置',
    MENU_CLOSE: '關閉',
    MENU_SELECT_ALL: '選擇全部',
    MENU_FILE: '文件',
    MENU_ABOUT: '{0} 信息',
    MENU_UPDATE: '確認更新',
    MENU_HIDE: '隱藏 {0}',
    MENU_HIDE_OTHERS: '隱藏其他App',
    MENU_SHOW_ALL: '顯示所有',
    MENU_QUIT: '{0} 停止',
    MENU_NEW_CHANNEL: '新房間',
    MENU_UNDO: '取消執行',
    MENU_REDO: '重新執行',
    MENU_CUT: '剪切',
    MENU_PASTE: '粘貼',
    MENU_PASTE_AND_MATCH_STYLE: '粘貼格式',
    MENU_RELOAD: '重新導入',
    MENU_FORCE_RELOAD: '強製導入',
    MENU_FULL_SCREEN: '轉換為全屏',
    MENU_RESET_ZOOM: '實際大小',
    MENU_ZOOM_IN: '擴大',
    MENU_ZOOM_OUT: '縮小',
    MENU_WINDOW: '窗口',
    MENU_MINIMIZE: '最小化',
    MENU_ZOOM: '最大化',
    MENU_HELP: '幫助',
    MESSAGE_UP_TO_DATE: '已是最新版本.',
    UPDATE_AVAILABLE: '有更新',
    MESSAGE_UPDATE_AVAILABLE: '可更新至最新版本.',
    MENU_EDIT: '編輯',
    MENU_COPY: '復制',
    UP_TO_DATE: '最新版本',
  },
  LOGIN__INSERT_EMAIL_HP: '請輸入email或是手機號碼.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE: '如忘記密碼，請在手機App重置密碼.',
  LOGIN__INSERT_PASSWORD: '請輸入密碼.',
  LOGIN__PASSWORD_INFORMATION: '忘記密碼了嗎?',
  BEFORE: '變更前',
  ALERT__NO_ONE_SELECTED: '未选择员工.',
  BASIC__: {
    ERROR: '發生錯誤. <br /> 麻煩請稍後再試一次.',
    MSG__: { INPUT: '請輸入關鍵字' },
    PWD_ALL_VALIDATION: '密碼必須包含%1$@~%2$@字的英文大小寫字母，數字和特殊符號.',
    RETRY: '重試',
    PASSWORD_RULE: '8-20個字符內的英文大小寫字母，數字，特殊符號的組合',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: '我的上下班紀錄查詢權限',
  },
  LOGOUT: '登出',
  COMMON__SECONDS: '秒',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: '取消編輯時，編輯的內容將不會被保存.',
      ARE_YOU_SURE_WANT_TO_STOP: '要取消編輯排班嗎？',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: '沒有添加的班次.' } },
  AWAY_TIME: '時',
  SETTINGS__CHANGE_LANGUAGE: '變更語言',
  SEARCH__MEMBER_PLACEHOLDER: '員工名/員工號/手機號',
  ' ': '設置為不使用時孕產婦管理功能將成為非激活狀態，相關記錄也將無法查詢.',
  BASIC__UNKNOWN: '未知',
  LOGIN__SERVER_ALERT: '無法連接到服務器.',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: '無法更新平臺消息.',
      LEAVE_CHANNEL: '無法退出平臺.',
      CREATE_CHANNEL: '無法建立頻道。',
    },
    FILE__: { MAXIMGSIZE: '已超出最大文件大小25MB.' },
    ALLOW_BROWSER_ALARM: '為了接收通知，請將瀏覽器設置內的通知更改為允許接收.',
    LABEL__: { SEARCH_MESSAGE: 'Search messages' },
    GUIDE__: { SEARCH_MESSAGE: 'Search for the message you want to find in {0}.' },
    BASIC__: { NO_SEARCH_RESULT: '沒有結果.' },
  },
  INVITE__MEMBER_SELECTION: '選擇成員',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: '所有參與者都可以看到更改的名稱.',
  NOTICE: '通知',
  INVITE__CREATE: '建立',
  CHANNEL__LEAVE_THIS_CHANNEL: '確定要推出頻道嗎？',
  LOGIN__PASSWORD_FAIL_COUNT: '已輸入{0}次錯誤密碼.',
  LOGIN__FAIL_ALERT: '連續輸入5次錯誤密碼時，將維持5分鐘鎖定狀態.',
  LOGIN__LOCK_STATE_ALERT: '因連續輸入錯誤密碼，已轉為5分鐘鎖定狀態.',
  LOGIN__RETRY_ALERT: '{0} 後, 請重試.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'ShoplChat密碼與手機App密碼相同.',
  SETTINGS__ALL_MESSAGES: '通知所有新消息',
  SETTINGS__ALARM_SOUND: '聲音',
  SETTINGS__SOUND_ALARM: '通知',
  SETTINGS__LISTEN_ALARM_SOUND: '接聽',
  ALERT__MAX_INVITE_MEMBER: '可以進入房間的最多人員為20,000名.',
  LOGIN__DEACTIVATED_ALERT: '管理者將聊天功能設置為非激活狀態，因而無法登錄.',
  LOGIN__SERVER_ALERT_CONTENTS: '網絡不穩定無法登錄. 請確認網絡連接後重新嘗試.',
  LOGIN__LOGOUT_ALERT: '已退出.',
  CHANNEL__EDIT_CHANNEL_NAME: '更改房間名稱',
  SETTINGS__THEME: '主題',
  SETTINGS__LANGUAGE: '語言',
  SETTINGS__LIGHT_THEME: '淺',
  SETTINGS__DARK_THEME: '暗',
  SEARCH__CHANNEL_PLACEHOLDER: '員工姓名',
  CHANNEL__CONTACT: '1:1 聊天',
  BASIC: { LABEL: { MAXIMAGECNT: '圖片最多可以上傳{0}個.' } },
  LOGIN__LOGIN_FAILED: 'ID或密碼輸入錯誤.',
  FORGOT_PW: '忘記密碼了嗎？',
  BASIC__MAX_FORMAT_INPUT: '最多可以輸入%@個字符.',
  SERVICE__COMING_SOON: '即將更新',
  LOGIN__GUIDE: '您可以通過應用賬號進行登錄.',
  MOBILE__: {
    ACCESS_PC: '請從PC端訪問後臺！',
    ACCESS_DESC_01: '後臺服務最適配於PC環境.',
    ACCESS_DESC_02: '為了更好的用戶體驗，請從PC端訪問.',
    ACCESS_PC_ONLY: '請從PC端訪問.',
    GUIDE: '聊天功能只能在PC或手機App使用.',
  },
  CHANNEL__NO_CHAT_HISTORY: '沒有對話記錄',
  LOGIN: '登入',
  LOGIN__PASSWORD: '輸入密碼',
  SEARCH__NO_RESULT: '沒有結果.',
  BASIC__SEARCH: '搜索',
};
